import createWebIcon from "../createWebIcon";
import type { IconProps } from "../Icon.props";
import validateKeys from "../validateKeys";

export default function Printer({ outline, ...props }: IconProps): JSX.Element {
  return outline ? (
    <Printer.Outline {...props} />
  ) : (
    <Printer.Solid {...props} />
  );
}

Printer.Outline = function Outline({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Outline`,
    path: (
      <>
        <path
          d="M4.5 18L4 18C2.89543 18 2 17.1046 2 16L2 10C2 8.89543 2.89543 8 4 8L20 8C21.1046 8 22 8.89543 22 10L22 16C22 17.1046 21.1046 18 20 18L19.5 18"
          className="icon-outline"
          strokeWidth="1.5"
        />
        <path
          d="M7 5C7 3.89543 7.89543 3 9 3H15C16.1046 3 17 3.89543 17 5V8H7L7 5Z"
          className="icon-outline"
          strokeWidth="1.5"
        />
        <path
          d="M7 15H17V19C17 20.1046 16.1046 21 15 21H9C7.89543 21 7 20.1046 7 19V15Z"
          className="icon-outline"
          strokeWidth="1.5"
        />
        <circle cx="19.5" cy="10.5" r="0.5" className="icon-outline" />
        <circle cx="17.5" cy="10.5" r="0.5" className="icon-outline" />
        <path d="M5 15H19" className="icon-outline" strokeWidth="1.5" />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};

Printer.Solid = function Solid({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Solid`,
    path: (
      <>
        <path
          d="M4.5 18L4 18C2.89543 18 2 17.1046 2 16L2 10C2 8.89543 2.89543 8 4 8L20 8C21.1046 8 22 8.89543 22 10L22 16C22 17.1046 21.1046 18 20 18L19.5 18"
          className="icon-primary"
        />
        <path
          d="M7 5C7 3.89543 7.89543 3 9 3H15C16.1046 3 17 3.89543 17 5V8H7L7 5Z"
          className="icon-primary"
        />
        <path
          d="M7 15H17V19C17 20.1046 16.1046 21 15 21H9C7.89543 21 7 20.1046 7 19V15Z"
          className="icon-primary"
        />
        <circle cx="19.5" cy="10.5" r="0.5" className="icon-primary" />
        <circle cx="17.5" cy="10.5" r="0.5" className="icon-primary" />
        <path d="M5 15H19" className="icon-primary" />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};
